import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { MONTHLY_OPTION, YEARLY_OPTION } from "../../../../constants/notification-key";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { MultiSelectOption } from "../../../../models/MultiSelectOption";
import { getDaysOfTheWeek, getRecurrenceOptionss } from "../../../../utilities/DateUtils";
import { validateNumberOfDays, validateEveryMonthNumber, validateMonthlyOption } from "../../../../utilities/Validation";
import Label from "../../../label/label";
import SettingSelectField from "../../../settingFields/SettingSelectField";

const Monthly: FC = () => {
    const { translate } = useLocale();
    const { setFieldValue, values } = useFormikContext<any>();

    const monthlyOptions: MultiSelectOption[] = [
        { value: MONTHLY_OPTION.DAY, label: translate.byKey(TranslationKeys.day) },
        { value: MONTHLY_OPTION.THE, label: translate.byKey(TranslationKeys.the) }
    ]

    const onMonthlyOptionsChanged = (option: MultiSelectOption) => {
        setFieldValue("monthlyOption", option.value);
    }

    return <div className="flex flex-row space-x-2">
        <div className="flex flex-col space-y-3">
            {monthlyOptions.map((option) => (
                <div
                    key={option.value}
                    className="flex items-center text-sm font-medium ">
                    <Field
                        id={`radio-${option.value}`}
                        type="radio"
                        name="monthlyOption"
                        value={option.value}
                        validate={(value) => validateMonthlyOption(value, translate)}
                        onChange={(_: any) => onMonthlyOptionsChanged(option)} />
                    <Label htmlFor={`radio-${option.value}`} className="pl-1 text-sm">{option.label}</Label>
                </div>
            ))}
        </div>
        <div className="flex flex-col space-y-2" >
            <div className="flex flex-row space-x-2">
                <Field
                    name="dayOfMonth"
                    valueName="dayOfMonth"
                    type="text"
                    validate={(value) => (values.monthlyOption === MONTHLY_OPTION.DAY) && validateNumberOfDays(value, translate)}
                    disabled={values.monthlyOption !== MONTHLY_OPTION.DAY}
                    className={`pl-1 text-sm w-16 h-6 bg-gray-input overflow-hidden ml-1 ${values.monthlyOption !== MONTHLY_OPTION.DAY ? 'text-gray-500 cursor-not-allowed' : ''}`} />
                <span >{translate.byKey(TranslationKeys.ofEvery)}</span>
                <Field
                    name="occurrences"
                    valueName="occurrences"
                    type="text"
                    validate={(value) => values.monthlyOption === MONTHLY_OPTION.DAY ? validateEveryMonthNumber(value, translate) : {}}
                    disabled={values.monthlyOption !== MONTHLY_OPTION.DAY}
                    className={`pl-1 text-sm w-16 h-6 bg-gray-input overflow-hidden ml-1 ${values.monthlyOption !== MONTHLY_OPTION.DAY ? 'text-gray-500 cursor-not-allowed' : ''}`} />
                <span >{translate.byKey(TranslationKeys.monthMonths)}</span>
            </div>
            <div className="flex flex-row space-x-3">
                <SettingSelectField
                    accessor="occurrence"
                    className={`w-32 pl-1 ${values.monthlyOption !== MONTHLY_OPTION.THE ? 'text-gray-500 cursor-not-allowed' : ''}`}
                    width="w-32"
                    required={values.monthlyOption === MONTHLY_OPTION.THE}
                    disabled={values.monthlyOption !== MONTHLY_OPTION.THE}
                    options={getRecurrenceOptionss(translate)} />
                <SettingSelectField
                    accessor="daysOfTheWeek"
                    className={`w-32 pl-1 ${values.monthlyOption !== MONTHLY_OPTION.THE ? 'text-gray-500 cursor-not-allowed' : ''}`}
                    width="w-32"
                    required={values.monthlyOption === MONTHLY_OPTION.THE}
                    disabled={values.monthlyOption !== MONTHLY_OPTION.THE}
                    options={getDaysOfTheWeek(translate)} />
                <span >{translate.byKey(TranslationKeys.ofEvery)}</span>
                <Field
                    name="occurrences"
                    valueName="occurrences"
                    type="text"
                    validate={(value) => validateEveryMonthNumber(value, translate)}
                    disabled={values.monthlyOption !== MONTHLY_OPTION.THE}
                    className={`p-1 text-sm w-16 h-6 bg-gray-input overflow-hidden ml-1 ${values.monthlyOption !== MONTHLY_OPTION.THE ? 'text-gray-500 cursor-not-allowed' : ''}`} />
                <span >{translate.byKey(TranslationKeys.monthMonths)}</span>
            </div>
        </div>
    </div>
}

export default Monthly;